<script setup lang="ts">
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import { type OpportunityType } from '@apparatix/types/Leads';
import { useOpportunityStore } from '@apparatix/stores/useOpportunityStore';

const props = defineProps<{ type: OpportunityType, visible: boolean }>();
const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'on:confirm', reasons: number[]): void;
}>();

const store = useOpportunityStore();

const selectedReasons = ref<number[]>([]);

const isVisible = computed({
  get: () => props.visible,
  set: () => emit('close'),
});

const disableSubmit = computed(() => {
  if (!selectedReasons.value) {
    return true;
  }

  if (selectedReasons.value.length === 0) {
    return true;
  }

  return false;
});

const onLost = () => {
  const reasons = [...selectedReasons.value];
  selectedReasons.value = [];
  emit('on:confirm', reasons);
};
</script>
<template>
  <Dialog
    v-model:visible="isVisible"
    header="Move Opportunity to Lost"
    style="width: 33vw"
    modal
  >
    <div class="flex flex-col gap-4">
      <div class="grow-0">
        <p class="text-sm font-normal text-[var(--swimlane--primary-)]">
          Please select the reasons for the loss of this Opportunity.
        </p>
      </div>
      <div class="grow grid grid-cols-2 grid-rows-3 gap-y-4 justify-items-stretch">
        <template v-for="reason in store.options[props.type].opportunityLostReasons" :key="reason.id">
          <div class="flex items-center gap-2 h-9">
            <Checkbox
              v-model="selectedReasons"
              :value="reason.id"
              name="reasons"
              :input-id="'opportunity-lost-budget-' + reason.id"
            />
            <label :for="'opportunity-lost-budget-' + reason.id">{{ reason.tag }}</label>
          </div>
        </template>
      </div>
      <div class="flex gap-2 justify-end items-center">
        <Button
          severity="secondary"
          size="small"
          @click="emit('close')"
        >
          Cancel
        </Button>
        <Button
          severity="danger"
          :disabled="disableSubmit"
          size="small"
          @click="onLost"
        >
          Lost
        </Button>
      </div>
    </div>
  </Dialog>
</template>
